import React, { FC } from 'react';

export const SingleVideo: FC = ({ children }) => {
  return <>{children}</>;
};
